import { ref } from 'vue'

// Shared in-memory auth state. Authentication itself is held by the server-side
// HttpOnly cookie; these refs contain only the current page's UI state.
export const authUser = ref(null)
export const authReady = ref(false)
export const authAuthorized = ref(false)
export const authRole = ref(null)
export const authDashboardAccess = ref(false)
export const authTeamIds = ref([])

export function resetAuthState() {
  authUser.value = null
  authAuthorized.value = false
  authRole.value = null
  authDashboardAccess.value = false
  authTeamIds.value = []
}
